import styled from 'styled-components';
import { media } from 'utils/style';

import AddressLineField from 'components/AddressModal/components/AddressLineField/container';

export default styled(AddressLineField)`
  ${media.lessThan('extraSmall')`
    .floating {
      .header {
        min-height: 100px;
        height: 100%;
      }
  }
  `}
`;
